import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxSpinnerModule],
  template: `<router-outlet></router-outlet>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.5)" [size]="'medium'" class="nv-spinner" [type]="'ball-clip-rotate'" [fullScreen]="true"> </ngx-spinner> `,
})
export class App {}
